/**
 * useLocalStorageState — small wrapper around useState that persists to
 * window.localStorage under a stable key. Used by the Iter-310b grouped
 * event cards to remember whether each event's role list is expanded
 * or collapsed across page reloads.
 *
 * Falls safe on private-mode browsers where setItem throws — the state
 * stays in-memory, the UI just won't remember on next reload.
 */
import { useEffect, useState } from 'react';

export default function useLocalStorageState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw == null) return initial;
      return JSON.parse(raw);
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // private mode / quota exceeded — ignore.
    }
  }, [key, value]);

  return [value, setValue];
}
